var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { AgentReleaseStatus } from "healthex-common/agent.release.dtos";
import { pick } from "healthex-common/utils";
import { computed, observable } from "mobx";
import { NamedRoutes } from "../NamedRoutes";
export class GlobalAdminAgentReleaseEditViewModel {
    constructor(container) {
        this.input = {
            version: "",
            semanticVersion: "",
            minimumVersion: false,
            deprecated: false,
            withdrawn: false,
        };
        this.agentReleaseService = container.agentReleaseService;
        this.routingUIManager = container.routingUIManager;
        void this.loadRelease();
    }
    updateUserInput(update) {
        this.input = { ...this.input, ...update };
    }
    get idToEdit() {
        var _a;
        return (_a = this.routingUIManager.currentRouteParams) === null || _a === void 0 ? void 0 : _a.id;
    }
    get title() {
        return this.idToEdit ? "Edit Agent Release" : "Create Agent Release";
    }
    async loadRelease() {
        if (!this.idToEdit)
            return;
        const release = await this.agentReleaseService.getAgentRelease(this.idToEdit);
        if (!release)
            return;
        this.input = {
            ...pick(release, "version", "semanticVersion", "minimumVersion"),
            deprecated: release.status === AgentReleaseStatus.DEPRECATED,
            withdrawn: release.status === AgentReleaseStatus.WITHDRAWN,
        };
    }
    async save() {
        const update = {
            ...pick(this.input, "version", "semanticVersion", "minimumVersion"),
            status: this.input.deprecated
                ? AgentReleaseStatus.DEPRECATED
                : this.input.withdrawn
                    ? AgentReleaseStatus.WITHDRAWN
                    : AgentReleaseStatus.ACTIVE,
        };
        if (this.idToEdit) {
            await this.agentReleaseService.updateAgentRelease(this.idToEdit, update);
        }
        else {
            await this.agentReleaseService.createAgentRelease(update);
        }
        this.routingUIManager.navigateTo(NamedRoutes.GLOBAL_ADMIN_AGENT_RELEASES);
    }
    cancel() {
        this.routingUIManager.navigateTo(NamedRoutes.GLOBAL_ADMIN_AGENT_RELEASES);
    }
}
__decorate([
    observable
], GlobalAdminAgentReleaseEditViewModel.prototype, "input", void 0);
__decorate([
    computed
], GlobalAdminAgentReleaseEditViewModel.prototype, "idToEdit", null);
__decorate([
    computed
], GlobalAdminAgentReleaseEditViewModel.prototype, "title", null);
